
import { useState} from 'react';
import { SelectField } from '../../formFields/SelectField';
import { checkIfFieldIsRequiredPerArchitecture } from '../../../../utilities/architectureTypeDataProcess';
import { getItemByValueInDropdownOptions } from '../../../../utilities/utilityFunctions';
import { useDataContext } from '../../../DataProvider/DataContext';
import { textHints } from '../../../../utilities/hintText';
import palette from '../../../../utilities/palette';
import { validateClusterValue } from '../../../../utilities/formValidation';

export default function Part2Selector({
        clusterEntry,
        machineList,
        setMachineList, 
        machineIndex, 
        variantIndex, 
        clusterIndex, 
        setMachineListErrors, 
        machineListErrors,
        projectKey,
        moduleName,
    }) {
    
    const {architectureType, api} = useDataContext();

    const [isLoading, setIsLoading] = useState(false);

    const [error, setError] = useState("");
    
    const handlePart2UrlGeneration = async () => {
        try {
            setError("");
            setIsLoading(true);

            if (shouldFetchButtonBeDisabled()) {
                setIsLoading(false);
                return;
            }
            
            const params = new URLSearchParams({ 
                clusterName: clusterEntry.clusterName,
                supplier: machineList[machineIndex].variantList[variantIndex].supplier,
                moduleName: moduleName,
                projectKey: projectKey,
            });
            const response = await api.fetch(`/srp/form/part2/urls/options?${params}`);

            if (!response.ok || response.status !== 200) {
                console.warn("Error when generating part2 URL options: ", response.statusText, await response.json());
                setIsLoading(false);
                return;
            }

            let part2UrlOptions = await response.json();
            if (!Array.isArray(part2UrlOptions) || part2UrlOptions.length === 0) {
                console.warn("No part2 URL options found");
                setMachineList((prevState) => {
                    const newState = structuredClone(prevState);
                    newState[machineIndex].variantList[variantIndex].clusterList[clusterIndex].part2UrlOptions = [];
                    return newState;
                });
                setIsLoading(false);
                return;
            }

            part2UrlOptions = part2UrlOptions.map(option => {
                return {
                    value: option,
                    label: option.split('/').pop().replace(/\.mdx$/, ''), // remove .mdx at the end for display
                }
            });

            if (part2UrlOptions.length === 0) {
                const errorMessage = "No valid part2 URL options found for the selected cluster and supplier based on the architecture type";
                console.warn(errorMessage);
                setError(errorMessage);
            }

            setMachineList((prevState) => {
                const newState = structuredClone(prevState);
                newState[machineIndex].variantList[variantIndex].clusterList[clusterIndex].part2UrlOptions = part2UrlOptions;
                return newState;
            });
            setIsLoading(false);
        } catch (error) {
            const errorMessage = error instanceof Error ? error.message : 'Unknown error';
            setError(`Unexpected error occurred while populating part2 URL options: ${errorMessage}`);
            setIsLoading(false);
            return [];
        }
    }

    return <>
            <div
            style={
                {
                    display: 'flex',
                    flexDirection: 'column',
                }
            }>

            <SelectField
                label="Part 2 Spec file"
                options={clusterEntry.part2UrlOptions || []}
                required={checkIfFieldIsRequiredPerArchitecture(`machineList.0.variantList.0.clusterList.0.part2SpecUrl`, architectureType)}
                value={getItemByValueInDropdownOptions(clusterEntry.part2UrlOptions || [], clusterEntry.part2SpecUrl)}
                placeholder={shouldFetchButtonBeDisabled() ? "Please select Supplier prior selecting Part 2 Spec file" : "--Please Select--"}
                isLoading={isLoading}
                onFocus={() => {
                    handlePart2UrlGeneration();
                }}
                onChange={(selectedOption) => handlePart2SelectionChange(selectedOption) }
                textHint={textHints.clusterContainer}
                errorMessage={machineListErrors[machineIndex]?.variantListErrors[variantIndex]?.clusterListErrors[clusterIndex]?.part2SpecUrlValidationError}
                pathToField={`machineList.0.variantList.0.clusterList.0.part2SpecUrl`} 
                stylingVariant='body'
            />
            
            <div style={{ color: palette.stepper.error, width: '560px', padding: '5px' }}>
                {error}
            </div>

            </div>
    </>;

    function shouldFetchButtonBeDisabled(): boolean {
        return false;
    }

    function handlePart2SelectionChange(selectedOption) {
        const selectedValue = selectedOption?.value || "";
        setMachineList((prevState) => {
            const newState = structuredClone(prevState);
            newState[machineIndex].variantList[variantIndex].clusterList[clusterIndex].part2SpecUrl = selectedValue;
            return newState;
        });
        
        // if not valid, set error. if valid, clear error

        validateClusterValue(machineIndex, variantIndex, clusterIndex, "part2SpecUrl", selectedValue, setMachineListErrors);

    }

}
